import angular from 'angular'
import { EntityStore } from './entity-store'

export type ReceiptTemplateTypesStore = EntityStore<'receiptTemplateTypes'>

/**
 * Stores information on the receipt template types.
 */
export const receiptTemplateTypesStore: ReceiptTemplateTypesStore = new EntityStore(
  {
    entityStoreName: 'receiptTemplateTypes',
    entityName: 'receipt_template_types',
    syncDeleted: true,
  }
)

/**
 * Responsible for persisting storage of receipt template types from the /api/2.0/receipt_template_types API end point into IndexedDB.
 *
 * @module receiptTemplateTypesStore
 */
angular
  .module('webregister.factories')
  .constant('receiptTemplateTypesStore', receiptTemplateTypesStore)
